import { FieldPath, FieldValues } from "react-hook-form";
import {
  ControlledToggleButton,
  ControlledToggleButtonProps,
} from "./controlled-toggle-button";
import { useTranslation } from "react-i18next";

type ControlledYesNoButtonProps<
  F extends FieldValues,
  N extends FieldPath<F>,
> = Omit<
  ControlledToggleButtonProps<F, N, boolean>,
  "options" | "errorTranslation"
>;

export const ControlledYesNoButton = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  rules,
  ...props
}: ControlledYesNoButtonProps<TFieldValues, TName>) => {
  const { t } = useTranslation();

  const yesNoOptions = [
    { value: true, label: t("components.yes_no.yes") },
    { value: false, label: t("components.yes_no.no") },
  ];

  return (
    <ControlledToggleButton
      {...props}
      rules={{
        validate: (value) => {
          if (rules?.required && value === undefined) {
            return false;
          }
          return true;
        },
      }}
      options={yesNoOptions}
      errorTranslation={t("common.validation.required")}
    />
  );
};
